import ReactPlayer from "react-player";
import { state } from "../../store";
import { useSnapshot } from "valtio";

export default function Ads() {
  const snap = useSnapshot(state);
  return !snap.showVideo ? null : (
    <div className="video-page">
      <ReactPlayer
        style={{ objectFit: "cover" }}
        url={"/model/Show.mp4"}
        muted={true}
        playing={true}
        width={"130%"}
        height={"130%"}
        onEnded={() => (state.showVideo = false)}
      />
      <h2 className="skipBtn" onClick={() => (state.showVideo = false)}>
        Skip Video
      </h2>
    </div>
  );
}
